module.exports = {"id":"217196","name":"José Luis Palomino","rating":"76","photo":"./data/images/photos/3/217196.png","club":{"name":"Atalanta","logo":"./data/images/clubs/Atalanta.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseLuisPalomino0.json
// module id = 2174
// module chunks = 0